import { connect } from 'react-redux';
import AdminManagement from '../component/AdminManagement';
import actAdmin from '../redux/actions/admin';
import actAuth from '../redux/actions/authorization';

const mapStateToProps = (state) => ({
  listAdmins: state.admin.listAdmins,
  listRoles: state.authorization.roles,
  actions: state.authorization.actions,
  mapPermissions: state.admin.mapPermissions,
  adminInfo: state.admin.adminInfo,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAllAdmins: (params, callback) => {
    dispatch(actAdmin.onFetchAllAdmin(params, callback));
  },
  fetchAdmins: (params, callback) => {
    dispatch(actAdmin.onFetchAdmins(params, callback));
  },
  fetchAdminLoginHistory: (params, callback) => {
    dispatch(actAdmin.onFetchAdminLoginHistory(params, callback));
  },
  onCreateAdmin: (params, callback) => {
    dispatch(actAdmin.onCreateAdmin(params, callback));
  },
  getRoleByPubkey: (pubkey, callback) => {
    dispatch(actAdmin.getRoleByPubkey(pubkey, callback));
  },
  postRoleForUser: (body, callback) => {
    dispatch(actAdmin.postRoleForUser(body, callback));
  },
  getRoles: () => {
    dispatch(actAuth.getRoles());
  },
  getRoleInfoById: (roleId, callback) => {
    dispatch(actAuth.getRoleInfoById(roleId, callback));
  },
  getAction: (callback) => {
    dispatch(actAuth.getAction(callback));
  },
  fetchAdminInfo: (params) => {
    dispatch(actAdmin.onFetchAdminInfo(params));
  },
  banAdmin: (params, callback) => {
    dispatch(actAdmin.onBanAdmin(params, callback));
  },
  unBanAdmin: (params, callback) => {
    dispatch(actAdmin.onUnBanAdmin(params, callback));
  },
  delAdmin: (params, callback) => {
    dispatch(actAdmin.onDelAdmin(params, callback));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(AdminManagement);
